import { render, staticRenderFns } from "./Advisor.vue?vue&type=template&id=0382da77&scoped=true&"
import script from "./Advisor.vue?vue&type=script&lang=js&"
export * from "./Advisor.vue?vue&type=script&lang=js&"
import style0 from "./Advisor.vue?vue&type=style&index=0&id=0382da77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0382da77",
  null
  
)

export default component.exports